import { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { IconPin, IconMail, IconGlobe, IconMonitor } from './Icons';
import { BrandInstagram, BrandFacebook, BrandLinkedIn } from './BrandIcons';
import './Footer.css';

const navGroups = [
  {
    title: 'Navigation',
    links: [
      { to: '/about',         label: 'About' },
      { to: '/research',      label: 'Research & Publications' },
      { to: '/awards',        label: 'Awards & Grants' },
      { to: '/organizations', label: 'Organizations' },
      { to: '/partnerships',  label: 'Partnerships' },
      { to: '/eco-village',   label: 'Eco-Village' },
      { to: '/speaking',      label: 'Speaking' },
      { to: '/gallery',       label: 'Gallery' },
      { to: '/contact',       label: 'Contact' },
    ],
  },
  {
    title: 'Affiliations',
    links: [
      { to: 'https://ugm.ac.id',      label: 'Universitas Gadjah Mada', ext: true },
      { to: 'https://globethics.net', label: 'Globethics',               ext: true },
      { to: 'https://yadema.org',     label: 'Yadema Foundation',        ext: true },
      { to: 'https://ykpai.org',      label: 'YKPI Foundation',          ext: true },
    ],
  },
];

export default function Footer() {
  const navigate = useNavigate();
  const [isNavigating, setIsNavigating] = useState(false);

  const handleAdminClick = (e) => {
    e.preventDefault();
    if (isNavigating) return;
    setIsNavigating(true);
    setTimeout(() => {
      navigate('/admin');
      setTimeout(() => {
        setIsNavigating(false);
      }, 500);
    }, 1200);
  };

  return (
    <footer className="footer">
      <div className="footer__inner container">
        {/* Brand column */}
        <div className="footer__brand">
          <Link to="/" className="footer__logo">
            <img src="/dr sofjan/2.jpeg" alt="Dicky Sofjan logo" className="footer__logo-monogram footer__logo-monogram--img" />
            <span className="footer__logo-name">Dicky Sofjan, <span style={{ fontSize: '0.85em', opacity: 0.8 }}>MPP, M.A., PH.D.</span></span>
          </Link>
          <p>Bridging high-level academic scholarship with transformative social action and ethical entrepreneurship.</p>
          <p className="footer__location"><IconPin size={12} color="currentColor" /> Yogyakarta, Indonesia</p>
          <div className="footer__social">
            <a href="mailto:dickysofjan@ugm.ac.id" aria-label="Email" className="footer__social-link"><IconMail size={16} color="currentColor" /></a>
            <a href="https://www.instagram.com/sofjandicky/" aria-label="Instagram" className="footer__social-link" target="_blank" rel="noopener noreferrer"><BrandInstagram size={20} /></a>
            <a href="https://web.facebook.com/dicky.sofjan/" aria-label="Facebook" className="footer__social-link" target="_blank" rel="noopener noreferrer"><BrandFacebook size={20} /></a>
            <a href="https://www.linkedin.com/in/dicky-sofjan-b11789118/" aria-label="LinkedIn" className="footer__social-link" target="_blank" rel="noopener noreferrer"><BrandLinkedIn size={20} /></a>
          </div>
        </div>

        {/* Nav columns */}
        {navGroups.map(group => (
          <div key={group.title} className="footer__col">
            <h4 className="footer__col-title">{group.title}</h4>
            <ul>
              {group.links.map(link => (
                <li key={link.label}>
                  {link.ext
                    ? <a href={link.to} target="_blank" rel="noopener noreferrer" className="footer__link">{link.label}</a>
                    : <Link to={link.to} className="footer__link">{link.label}</Link>
                  }
                </li>
              ))}
            </ul>
          </div>
        ))}

        {/* CTA column */}
        <div className="footer__col footer__cta-col">
          <h4 className="footer__col-title">Let's Connect</h4>
          <p>Academic inquiries, speaking invitations, and media requests welcome.</p>
          <Link to="/contact" className="btn btn-gold btn-sm">Send a Message</Link>
          <div className="footer__contact-links">
            <a href="mailto:dickysofjan@ugm.ac.id">dickysofjan@ugm.ac.id</a>
            <span>·</span>
            <a href="https://globethics.net" target="_blank" rel="noopener noreferrer">globethics.net</a>
          </div>
        </div>
      </div>

      <div className="footer__bottom">
        <div className="container">
          <span>© {new Date().getFullYear()} Dr. Dicky Sofjan. All rights reserved.</span>
          <span>Academic Faculty, Universitas Gadjah Mada · Vice President, Globethics Switzerland</span>
          <Link 
            to="/admin" 
            className={`footer__admin-link ${isNavigating ? 'footer__admin-link--loading' : ''}`}
            onClick={handleAdminClick}
          >
            <IconMonitor size={14} color="currentColor" /> Admin Portal
          </Link>
        </div>
      </div>

      {/* Full screen loading transition */}
      {isNavigating && (
        <div className="footer__loading-overlay" role="dialog" aria-modal="true" aria-label="Loading Admin Console">
          <div className="footer__loading-content">
            <svg className="footer__loading-spinner" width="48" height="48" viewBox="0 0 24 24" fill="none" stroke="var(--gold)" strokeWidth="2">
              <circle cx="12" cy="12" r="10" stroke="rgba(255, 255, 255, 0.05)" strokeLinecap="round" />
              <path d="M12 2a10 10 0 0 1 10 10" strokeLinecap="round" />
            </svg>
            <h3 className="footer__loading-text">Initializing Secure Console</h3>
            <span className="footer__loading-sub">Dr. Dicky Sofjan CMS Portal</span>
          </div>
        </div>
      )}
    </footer>
  );
}
